module.exports = __webpack_public_path__ + "startpage-746fed5a/cover-letter-bg-50a9885bf1f207f9fa75a7e8efd1953a.svg";